// extracted by mini-css-extract-plugin
export default {"title":"title__2+Mdo","list":"list__T1JCn","img":"img__LzySG","card":"card__YJjsb","card_items":"card_items__M5chz","card_item":"card_item__AAB84"};